<div class="row">
    <div class="col-sm-4 border-right border-success">
        <label class="label composicion-title" (click)="editarComposicion('macronutrientes')"><span>Macronutrientes</span><nb-icon icon="edit-outline"></nb-icon></label>

        <nb-tag-list>
          <nb-tag appearance="outline" size="tiny" *ngFor="let item of composicion.macronutrientes" [text]="item.value + ' % ' + item.name" status="success"></nb-tag>
        </nb-tag-list>
    </div>
    <div class="col-sm-4 border-right border-success">
        <label class="label composicion-title" (click)="editarComposicion('metalespesados')"><span>Metales pesados</span><nb-icon icon="edit-outline"></nb-icon></label>
        <nb-tag-list>
          <nb-tag appearance="outline" size="tiny" *ngFor="let item of composicion.metalespesados" [text]="item.value + ' % ' + item.name" status="success"></nb-tag>
        </nb-tag-list>
    </div>
    <div class="col-sm-4">
        <label class="label composicion-title" (click)="editarComposicion('micronutrientes')"><span>Micronutrientes</span><nb-icon icon="edit-outline"></nb-icon></label>
        <nb-tag-list>
          <nb-tag appearance="outline" size="tiny" *ngFor="let item of composicion.micronutrientes" [text]="item.value + ' % ' + item.name" status="success"></nb-tag>
        </nb-tag-list>
    </div>
</div>


<ng-template #editarcomposicion let-data let-ref="dialogRef">
  <nb-card class="editar-composicion-card">
    <nb-card-header>Editar {{data.composicionData.title}}</nb-card-header>
    <nb-card-body>

      <div class="row">
        <div *ngFor="let item of data.composicionData.composicion" class="col-sm-4">
          <div class="form-group">
            <label  class="label">{{item.name}}</label>
            <input nbInput fullWidth type="number" [(ngModel)]="item.value">
          </div>
        </div>
      </div>





    </nb-card-body>
    <nb-card-footer>
      <div class="row">
        <div class="col-md-6">
          <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
        </div>
        <div class="col-md-6 text-right">
          <button nbButton status="danger" (click)="actualizarComposicion(data.composicionData.tipo,data.composicionData.composicion);ref.close()">Guardar</button>
        </div>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
